import styled from '@emotion/styled'

export const LabelValueRowLabel = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
`

/* A block, not a flex column: a flex item drops the text's half-leading and sits above the label. */
export const LabelValueRowValue = styled.div`
  flex: 1;
  min-width: 0;
  text-align: right;
`
